<template>
  <div class="email-preferences">
    <div class="container">
      <b-headline type="h3" typography="h3" class="mb-6 m:mb-10 text-left" v-html="$t('emailPreferences.headline')" />

      <div v-if="!isLoading">
        <category-preference :email-preferences="filteredEmailPreferences" :update-callback="updateEmailPreference" />

        <all-preferences :email-preferences="emailPreferences" :update-callback="updateEmailSubscriptionStatus" />
      </div>
      <div v-else>
        <skeleton-screen />
      </div>

      <notification class="mb-12 m:mb-16">
        <div v-html="pushNotificationsInfo" />
      </notification>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import BHeadline from "@/component-library/b-headline"
import Notification from "@/shared/notification"
import SkeletonScreen from "@/component-library/skeleton-screen"
import AllPreferences from "./all-preferences"
import CategoryPreference from "./category-preference"

export default {
  name: "EmailPreferences",
  components: {
    BHeadline,
    Notification,
    SkeletonScreen,
    AllPreferences,
    CategoryPreference
  },
  data() {
    return {
      isLoading: true
    }
  },
  computed: {
    ...mapGetters("settings", ["emailPreferences"]),
    ...mapGetters(["downloadAppUrl"]),
    pushNotificationsInfo() {
      return this.$t("emailPreferences.pushNotificationsInfo", {
        url: this.downloadAppUrl({
          deeplinkPath: "push-notifications",
          buttonCode: "link-20210714-email-preferences-app-settings-deeplink"
        })
      })
    },
    filteredEmailPreferences() {
      if (!this.emailPreferences) {
        return {}
      }

      const { other, ...filteredPreferences } = this.emailPreferences

      return filteredPreferences
    }
  },
  async mounted() {
    await this.loadEmailPreferences()
    this.isLoading = false
  },
  methods: {
    ...mapActions("settings", ["loadEmailPreferences", "updateEmailPreference", "updateEmailSubscriptionStatus"])
  }
}
</script>
